export const NotificationInfoIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      rx="12"
      fill="#4483E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.90001 5.70001C7.58042 5.70001 5.70001 7.58042 5.70001 9.90001V14.1C5.70001 16.4196 7.58042 18.3 9.90001 18.3H14.1C16.4196 18.3 18.3 16.4196 18.3 14.1V9.90001C18.3 7.58042 16.4196 5.70001 14.1 5.70001H9.90001ZM9.90001 7.10001C8.35362 7.10001 7.10001 8.35362 7.10001 9.90001V14.1C7.10001 15.6464 8.35362 16.9 9.90001 16.9H14.1C15.6464 16.9 16.9 15.6464 16.9 14.1V9.90001C16.9 8.35362 15.6464 7.10001 14.1 7.10001H9.90001Z"
      fill="white"
    />
    <path
      d="M13.4 10.6L10.6 10.6V12H11.3V14.128H10.6V15.5L13.4 15.5V14.128L12.7 14.1V12H13.4V10.6Z"
      fill="white"
    />
    <path
      d="M11.3 8.50004H12.7V9.90004L11.3 9.90004V8.50004Z"
      fill="white"
    />
  </svg>
);
